import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16 21.5L7 12.5L16 3.5", stroke: "#8F8F8F", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCarouselArrowLeft);
export { ForwardRef as ReactComponent };
